/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { GmcErrorDirective } from './gmc-error.directive';
import { GmcErrorsRegistry } from './gmc-errors-registry';

type Control = AbstractControl | FormGroup;

@Component({
  selector: 'mat-error[gmc-errors]',
  templateUrl: './gmc-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [GmcErrorDirective, NgTemplateOutlet, AsyncPipe],
  providers: [GmcErrorsRegistry],
})
export class GmcErrorsComponent {
  control!: Control;
  error$!: Observable<string | void>;
  private registry = inject(GmcErrorsRegistry);

  @Input('gmc-errors')
  set gmcErrors(value: Control | undefined | null) {
    if (!value) {
      console.warn('No FormControl has been passed into gmcErrors.');
      return;
    }
    this.control = value;
    this.error$ = value.statusChanges.pipe(
      startWith(value.status),
      map((status) =>
        status === 'INVALID' && this.control.errors ? Object.keys(this.control.errors).shift() : void 0,
      ),
    );
  }

  @Input('gmc-errors-label')
  label = 'Value';

  public getErrorTemplate(error: string) {
    return this.registry.getErrorTemplate(error);
  }
}
